// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class InMemoryStorageService {
//   private storage: Map<string, any> = new Map();

//   // Store data in both in-memory and sessionStorage
//   set(key: string, value: any): void {
//     this.storage.set(key, value);
//     sessionStorage.setItem(key, JSON.stringify(value));
//   }

//   // Retrieve data, prefer in-memory, fallback to sessionStorage
//   get(key: string): any {
//     if (this.storage.has(key)) {
//       return this.storage.get(key);
//     }
//     const sessionValue = sessionStorage.getItem(key);
//     if (sessionValue !== null) {
//       const parsed = JSON.parse(sessionValue);
//       this.storage.set(key, parsed); // keep in sync
//       return parsed;
//     }
//     return null;
//   }

//   update(key: string, value: any): void {
//     if (this.storage.has(key) || sessionStorage.getItem(key) !== null) {
//       this.set(key, value);
//     }
//   }

//   delete(key: string): void {
//     this.storage.delete(key);
//     sessionStorage.removeItem(key);
//   }

// getAll(): { [key: string]: any } {
//   const allData: { [key: string]: any } = {};
//   // Merge sessionStorage and in-memory
//   for (let i = 0; i < sessionStorage.length; i++) {
//     const key = sessionStorage.key(i);
//     if (key) {
//       const value = sessionStorage.getItem(key);
//       try {
//         allData[key] = JSON.parse(value!);
//       } catch (e) {
//         // If not valid JSON, store as string
//         allData[key] = value;
//       }
//     }
//   }
//   this.storage.forEach((value, key) => {
//     allData[key] = value;
//   });
//   return allData;
// }

//   clear(): void {
//     this.storage.clear();
//     sessionStorage.clear();
//   }
// }
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InMemoryStorageService {
  private storage: Map<string, any> = new Map();

  // Store data in both in-memory and localStorage
  set(key: string, value: any): void {
    this.storage.set(key, value);
    localStorage.setItem(key, JSON.stringify(value));
  }

  // Retrieve data, prefer in-memory, fallback to localStorage
  get(key: string): any {
    if (this.storage.has(key)) {
      return this.storage.get(key);
    }
    const localValue = localStorage.getItem(key);
    if (localValue !== null) {
      const parsed = JSON.parse(localValue);
      this.storage.set(key, parsed); // keep in sync
      return parsed;
    }
    return null;
  }

  update(key: string, value: any): void {
    if (this.storage.has(key) || localStorage.getItem(key) !== null) {
      this.set(key, value);
    }
  }

  delete(key: string): void {
    this.storage.delete(key);
    localStorage.removeItem(key);
  }

  getAll(): { [key: string]: any } {
    const allData: { [key: string]: any } = {};
    // Merge localStorage and in-memory
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key) {
        const value = localStorage.getItem(key);
        try {
          allData[key] = JSON.parse(value!);
        } catch (e) {
          // If not valid JSON, store as string
          allData[key] = value;
        }
      }
    }
    this.storage.forEach((value, key) => {
      allData[key] = value;
    });
    return allData;
  }

  clear(): void {
    this.storage.clear();
    localStorage.clear();
  }
}